import { apiClient } from "../Config/ApiClient";

export const retrieveDisclosure = (lang, token) => apiClient.get(`/disclosures`, { params: { lang: lang}, headers: { 'Authorization': token }} );

export const retrieveDisclosures = (startDate, endDate, icode, lang, page, perPage, mType, token) => apiClient.get(`/disclosure/all` ,
        {
            params: {
                start_date: startDate,
                end_date: endDate,
                icode: icode,
                lang: lang,
                page: page,
                per_page: perPage,
                m_type: mType
            },
            headers: { 'Authorization': token }
        }
    );

export const retrieveDisclosureShow = (id, token) => apiClient.get(`/disclosure/${id}`, { headers: { 'Authorization': token } });